import { CLAIM_STATUS } from 'containers/data-structure';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { get, isNil, every, map } from 'lodash';
import { VictimType } from 'typings/globalTypes';

export const isMonitoringCourtManager = () => {
  return userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER);
};

export const isTransactionManager = () => {
  return userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER);
};

export const resolveSagisClaim = (policyInfo: any) => {
  const claimNumber = get(
    get(policyInfo, 'corporeal', []).find(
      (c: any) => c.status !== CLAIM_STATUS.REJECTED,
    ),
    'claimNumber',
  );
  const claim = get(policyInfo, 'sagis.claims', []).find(
    (c: { code: string }) => c.code === claimNumber,
  );
  return claim;
};

export const isAllValuesIsNil = (object: any) => {
  return every(object, isNil);
};
export const shouldShowVictimExcludedWarning = (
  victims: any[],
  fflip: boolean,
) => {
  const isExcluded = map(victims, (victim: VictimType) =>
    get(victim, 'isExcluded'),
  );
  return isExcluded.some((excluded: boolean) => excluded) && fflip;
};

export const formatLabel = (
  label: string,
  index: string,
  isProceedingCivil: boolean,
) => {
  if (!isProceedingCivil) {
    return label;
  } else {
    return label + ' ' + index;
  }
};

export const getUserPrivileges = () => {
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const isCourtManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );
  const isPreOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );
  const isCourtMonitoringManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMONITORINGMANAGER,
  );

  const isManagerOpeningManager =
    userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) &&
    userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER);

  const isTransactionManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISTRANSACTIONMANAGER,
  );
  return {
    isOpeningManager,
    isCourtManager,
    isCourtMonitoringManager,
    isManagerOpeningManager,
    isTransactionManager,
    isPreOpeningManager,
  };
};
